import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Zotter Chocolates — New-customers campaign (adc_4umu49yjzf). Real lifetime
// aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS over the 29 complete months
// Mar 2024 – Jul 2026. Monthly series lives in realBrandData.ts.
//
// `salesDollars` is booked sales and `bestEstimateSalesDollars` is the first-year
// projection; unlike the other variants the two genuinely differ here ($59.6k
// booked against a $54.3k projection, because most of this program's cohorts have
// outrun their first year). They come from different columns, so neither one can
// be derived from the other or from the ROAS.
export const campZcNew: FaireAdCampaignEntity = {
  token: "camp_zc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_zotter_chocolates",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 800,
  startedRunningAt: "2024-03-08",
  segmentMetrics: {
    numCustomersAcquired: 69,
    salesDollars: 59559,
    totalAdsSpendDollars: 7014,
    cpaDollars: 102,
    bestEstimateSalesDollars: 54265,
    bestEstimateRoas: 7.74,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-30T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
